import { render, staticRenderFns } from "./HyphenSideDrawer.vue?vue&type=template&id=846d20ba&scoped=true"
import script from "./HyphenSideDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenSideDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenSideDrawer.vue?vue&type=style&index=0&id=846d20ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846d20ba",
  null
  
)

export default component.exports